import React, { useEffect, useState, useMemo } from "react";
import Select from "react-select";
import { getCityList } from "../../utils/Helpers/GetCityTypes";

export default function CityFilter({
  onSelectCity,
  reset,
  borderTrue,
  county,
  preSelectedCity,
  isDisabled,
}) {
  const [city, setCity] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedState] = useState(
    JSON.parse(localStorage.getItem("selectedState")) || null
  );
  useEffect(() => {
    const loadCity = async () => {
      if (selectedState?.value) {
        const cities = await getCityList(selectedState.value);
        setCity(cities);
      }
    };

    loadCity();
  }, [selectedState]);

  useEffect(() => {
    if (reset) {
      setSelectedCity(null);
    }
  }, [reset]);

  const handleChange = (event) => {
    const city = event;
   
    setSelectedCity(city);
    onSelectCity(city?.value);
  };

  const filteredCities = useMemo(() => {
    return county ? city.filter((c) => c.county_name === county) : city;
  }, [city, county]);

  const transformedCountries = useMemo(() => {
    return filteredCities.map((city) => ({
      value: city.id,
      label: city.name,
    }));
  }, [filteredCities]);
  
  useEffect(() => {
    setSelectedCity(null); // Unset city when county changes
  }, [county]);
  useEffect(() => {
    if (preSelectedCity && transformedCountries.length > 0) {
      // Sort the countries alphabetically by label
      const sortedCountries = [...transformedCountries].sort((a, b) =>
        a.label.localeCompare(b.label)
      );

     
      const match = sortedCountries.find(
        (item) => item.value === preSelectedCity
      );

      if (match) {
        setSelectedCity(match);
      }

    
    }
  }, [preSelectedCity, transformedCountries]);

  return (
    <Select
      theme={(theme) => ({
        ...theme,
        borderRadius: 0,
      })}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          borderColor: "#9FAFCA",
          borderWidth: "3px",
          borderTop: !borderTrue && "none",
          borderLeft: !borderTrue && "none",
          borderRight: !borderTrue && "none",
          boxShadow: borderTrue && "none",
          "&:hover": {
            borderColor: "#2684FF",
          },
        }),
        dropdownIndicator: (provided, state) => ({
          ...provided,
          color: "#a71e1e",
        }),
        placeholder: (provided) => ({
          ...provided,
          color: "#6c757d",
        }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isSelected ? "#9FAFCA" : "white",
          color: state.isSelected ? "white" : "black",
          "&:hover": {
            backgroundColor: "#9FAFCA",
            color: "white",
          },
        }),
        menu: (provided) => ({
          ...provided,
          zIndex: 9999,
          borderRadius: 0,
        }),
      }}
      options={transformedCountries}
      value={selectedCity}
      onChange={handleChange}
      placeholder="CITY"
      isSearchable
      isDisabled={isDisabled}
    />
  );
}
